module.exports = "/* You can add global styles to this file, and also import other style files */\n\n.alert p {\n    margin: 0;\n    padding: 0;\n}"